module.exports = __webpack_public_path__ + "img/jsbank.09def6c7.png";